/**
 * Background
 */
export const background = [
  {
    id: "bg-1",
    value: "from-green-300 via-blue-500 to-purple-600",
    selected: false,
  },
  {
    id: "bg-2",
    value: "from-bg-2-1 to-bg-2-2",
    selected: true,
  },
  {
    id: "bg-3",
    value: "from-rose-400 via-fuchsia-500 to-indigo-500",
    selected: false,
  },
  {
    id: "bg-4",
    value: "from-pink-300 via-purple-300 to-indigo-400",
    selected: false,
  },
  {
    id: "bg-5",
    value: "bg-gradient-to-r from-rose-500 via-red-400 to-red-500",
    selected: false,
  },
];

/**
 * Background Color
 */
export const backgroundColor = [
  {
    value: "bg-gray-700",
    ring: "ring-gray-700",
  },
  {
    value: "bg-red-500",
    ring: "ring-red-500",
  },
  {
    value: "bg-orange-500",
    ring: "ring-orange-500",
  },
  {
    value: "bg-yellow-400",
    ring: "ring-yellow-400",
  },
  {
    value: "bg-lime-500",
    ring: "ring-lime-500",
  },
  {
    value: "bg-green-500",
    ring: "ring-green-500",
  },
  {
    value: "bg-emerald-500",
    ring: "ring-emerald-500",
  },
  {
    value: "bg-teal-500",
    ring: "ring-teal-500",
  },
  {
    value: "bg-cyan-500",
    ring: "ring-cyan-500",
  },
  {
    value: "bg-blue-500",
    ring: "ring-blue-500",
  },
  {
    value: "bg-indigo-500",
    ring: "ring-indigo-500",
  },
  {
    value: "bg-violet-500",
    ring: "ring-violet-500",
  },
  {
    value: "bg-purple-500",
    ring: "ring-purple-500",
  },
  {
    value: "bg-fuchsia-500",
    ring: "ring-fuchsia-500",
  },
  {
    value: "bg-pink-500",
    ring: "ring-pink-500",
  },
  {
    value: "bg-rose-500",
    ring: "ring-rose-500",
  },
];

/**
 * Code Theme
 */
export const codeTheme = [
  {
    value: "Abbott",
    selected: false,
    theme: "dark",
  },

  {
    value: "Ayu Dark",
    selected: false,
    theme: "dark",
  },
  {
    value: "Ayu Mirage",
    selected: false,
    theme: "dark",
  },
  {
    value: "Base16 Dark",
    selected: false,
    theme: "dark",
  },
  {
    value: "Base16 Light",
    selected: false,
    theme: "light",
  },
  {
    value: "Dracula",
    selected: false,
    theme: "dark",
  },
  {
    value: "Duotone Dark",
    selected: false,
    theme: "dark",
  },
  {
    value: "Github Dark",
    selected: false,
    theme: "dark",
  },
  {
    value: "Github Light",
    selected: false,
    theme: "light",
  },
  {
    value: "Material",
    selected: false,
    theme: "dark",
  },
  {
    value: "Midnight",
    selected: false,
    theme: "dark",
  },
  {
    value: "Monokai",
    selected: false,
    theme: "dark",
  },
  {
    value: "Mreq",
    selected: false,
    theme: "dark",
  },
  {
    value: "Nord",
    selected: false,
    theme: "dark",
  },
  // {
  //   value: "Oceanic",
  //   selected: false,
  //   theme: "dark",
  // },
  {
    value: "One Dark",
    selected: false,
    theme: "dark",
  },
  {
    value: "One Light",
    selected: true,
    theme: "light",
  },
  {
    value: "Tomorrow Night-Eighties",
    selected: false,
    theme: "dark",
  },
  {
    value: "Venom",
    selected: false,
    theme: "dark",
  },
];

/**
 * Code Language
 */
export const codeLang = [
  {
    value: "APL",
    selected: false,
  },
  {
    value: "ASN.1",
    selected: false,
  },
  {
    value: "Asterisk ",
    selected: false,
  },
  {
    value: "Brainfuck",
    selected: false,
  },
  {
    value: "C, C++, C#",
    selected: false,
  },

  {
    value: "Clojure",
    selected: false,
  },

  {
    value: "CMake",
    selected: false,
  },
  {
    value: "COBOL",
    selected: false,
  },
  {
    value: "CoffeeScript",
    selected: false,
  },
  {
    value: "Common-Lisp",
    selected: false,
  },
  {
    value: "Crystal",
    selected: false,
  },
  {
    value: "CSS",
    selected: false,
  },
  {
    value: "Cypher",
    selected: false,
  },
  {
    value: "Cython",
    selected: false,
  },
  {
    value: "D",
    selected: false,
  },
  {
    value: "Dart",
    selected: false,
  },
  {
    value: "Django",
    selected: false,
  },
  {
    value: "Dockerfile",
    selected: false,
  },
  {
    value: "diff",
    selected: false,
  },
  {
    value: "DTD",
    selected: false,
  },
  {
    value: "Dylan",
    selected: false,
  },
  {
    value: "EBNF",
    selected: false,
  },
  {
    value: "ECL",
    selected: false,
  },
  {
    value: "Eiffel",
    selected: false,
  },

  {
    value: "Elm",
    selected: false,
  },
  {
    value: "Erlang",
    selected: false,
  },
  {
    value: "Factor",
    selected: false,
  },
  {
    value: "FCL",
    selected: false,
  },
  {
    value: "Forth",
    selected: false,
  },
  {
    value: "Fortran",
    selected: false,
  },

  {
    value: "Gas",
    selected: false,
  },
  {
    value: "Gherkin",
    selected: false,
  },
  {
    value: "Go",
    selected: false,
  },
  {
    value: "Groovy",
    selected: false,
  },
  {
    value: "HAML",
    selected: false,
  },
  {
    value: "Handlebars",
    selected: false,
  },
  {
    value: "Haskell",
    selected: false,
  },
  {
    value: "Haxe",
    selected: false,
  },
  {
    value: "HTTP",
    selected: false,
  },
  {
    value: "IDL",
    selected: false,
  },
  {
    value: "Java",
    selected: false,
  },
  {
    value: "JavaScript",
    selected: true,
  },
  {
    value: "Jinja2",
    selected: false,
  },
  {
    value: "Julia",
    selected: false,
  },
  {
    value: "Kotlin",
    selected: false,
  },
  {
    value: "LESS",
    selected: false,
  },
  {
    value: "LiveScript",
    selected: false,
  },
  {
    value: "Lua",
    selected: false,
  },
  {
    value: "Markdown",
    selected: false,
  },
  {
    value: "Mathematica",
    selected: false,
  },
  {
    value: "mbox",
    selected: false,
  },
  {
    value: "mIRC",
    selected: false,
  },
  {
    value: "Modelica",
    selected: false,
  },
  {
    value: "MscGen",
    selected: false,
  },
  {
    value: "MUMPS",
    selected: false,
  },
  {
    value: "Nginx",
    selected: false,
  },
  {
    value: "NSIS",
    selected: false,
  },
  {
    value: "NTriples",
    selected: false,
  },
  {
    value: "Objective C",
    selected: false,
  },

  {
    value: "Octave",
    selected: false,
  },
  {
    value: "Oz",
    selected: false,
  },
  {
    value: "Pascal",
    selected: false,
  },
  {
    value: "PEGjs",
    selected: false,
  },
  {
    value: "Perl",
    selected: false,
  },
  {
    value: "PGP",
    selected: false,
  },
  {
    value: "PHP",
    selected: false,
  },
  {
    value: "Pig",
    selected: false,
  },
  {
    value: "PowerShell",
    selected: false,
  },
  {
    value: "Properties",
    selected: false,
  },
  {
    value: "ProtoBuf",
    selected: false,
  },
  {
    value: "Pug",
    selected: false,
  },
  {
    value: "Puppet",
    selected: false,
  },
  {
    value: "Python",
    selected: false,
  },
  {
    value: "Q",
    selected: false,
  },
  {
    value: "R",
    selected: false,
  },
  {
    value: "RPM",
    selected: false,
  },

  {
    value: "Ruby",
    selected: false,
  },
  {
    value: "Rust",
    selected: false,
  },
  {
    value: "SAS",
    selected: false,
  },
  {
    value: "Sass",
    selected: false,
  },

  {
    value: "Scheme",
    selected: false,
  },

  {
    value: "Shell",
    selected: false,
  },
  {
    value: "Sieve",
    selected: false,
  },
  {
    value: "Slim",
    selected: false,
  },
  {
    value: "Smalltalk",
    selected: false,
  },
  {
    value: "Smarty",
    selected: false,
  },
  {
    value: "Solr",
    selected: false,
  },
  {
    value: "Soy",
    selected: false,
  },

  {
    value: "SQL",
    selected: false,
  },

  {
    value: "Swift",
    selected: false,
  },
  {
    value: "sTeX",
    selected: false,
  },
  {
    value: "Tcl",
    selected: false,
  },
  {
    value: "Textile",
    selected: false,
  },
  {
    value: "Tiddlywiki",
    selected: false,
  },
  {
    value: "Tiki",
    selected: false,
  },
  {
    value: "TOML",
    selected: false,
  },
  {
    value: "Tornado",
    selected: false,
  },
  {
    value: "troff",
    selected: false,
  },
  {
    value: "TTCN",
    selected: false,
  },
  {
    value: "Turtle",
    selected: false,
  },
  {
    value: "Twig",
    selected: false,
  },
  {
    value: "VB.NET",
    selected: false,
  },
  {
    value: "VBScript",
    selected: false,
  },
  {
    value: "Velocity",
    selected: false,
  },
  {
    value: "Verilog",
    selected: false,
  },
  {
    value: "VHDL",
    selected: false,
  },
  {
    value: "Vue",
    selected: false,
  },
  {
    value: "WebIDL",
    selected: false,
  },
  {
    value: "XML",
    selected: false,
  },
  {
    value: "XQuery",
    selected: false,
  },
  {
    value: "Yacas",
    selected: false,
  },
  {
    value: "YAML",
    selected: false,
  },
  {
    value: "Z80",
    selected: false,
  },
];

/**
 * Presets
 */
export const getPresets = () => {};

/**
 * Controls
 */
export const controls = [
  {
    id: 1,
    value:"control_1",
    imageURL: "/icons/control_1.svg",
    selected: false,
    rounded: true,
    controls: false,
  },
  {
    id: 2,
    value:"control_2",
    imageURL: "/icons/control_2.svg",
    selected: true,
    rounded: true,
    controls: true,
  },
  {
    id: 3,
    value:"control_3",
    imageURL: "/icons/control_3.svg",
    selected: false,
    rounded: false,
    controls: true,
  },
];

/**
 * Shadow
 */
export const shadow = [
  {
    value: "sm",
    selected: false,
  },
  {
    value: "md",
    selected: true,
  },
  {
    value: "lg",
    selected: false,
  },
  {
    value: "xl",
    selected: false,
  },
];

/**
 * Font Family
 */
export const family = [
  {
    value: "Fira Code",
    selected: true,
  },
  {
    value: "Roboto Mono",
    selected: false,
  },
  {
    value: "Space Mono",
    selected: false,
  },
  {
    value: "JetBrains Mono",
    selected: false,
  },
  {
    value: "Source Code Pro",
    selected: false,
  },
];

/**
 * Font Size
 */
export const size = [
  {
    value: "xs",
    selected: false,
  },
  {
    value: "sm",
    selected: true,
  },
  {
    value: "base",
    selected: false,
  },
  {
    value: "lg",
    selected: false,
  },
  {
    value: "xl",
    selected: false,
  },
  {
    value: "2xl",
    selected: false,
  },
  {
    value: "3xl",
    selected: false,
  },
  {
    value: "4xl",
    selected: false,
  },
  {
    value: "5xl",
    selected: false,
  },
];

/**
 * Font Family
 */
export const type = [
  {
    value: "Light",
    selected: false,
  },
  {
    value: "Regular",
    selected: true,
  },
  {
    value: "Medium",
    selected: false,
  },
  {
    value: "Semi Bold",
    selected: false,
  },
  {
    value: "Bold",
    selected: false,
  },
];

/**
 * Line Height
 */
export const lineHeight = [
  {
    value: "None",
    selected: false,
  },
  {
    value: "Tight",
    selected: false,
  },
  {
    value: "Snug",
    selected: false,
  },
  {
    value: "Normal",
    selected: true,
  },
  {
    value: "Relaxed",
    selected: false,
  },
  {
    value: "Loose",
    selected: false,
  },
];

/**
 * All Menus
 */
export const allMenus = [
  {
    txt: "Theme",
    icon: "ri-paint-fill",
    id: "theme",
    selected: false,
  },
  {
    txt: "Editor",
    icon: "ri-code-box-fill",
    id: "editor",
    selected: false,
  },
  {
    txt: "Window",
    icon: "ri-window-fill",
    id: "window",
    selected: false,
  },
  {
    txt: "Export",
    icon: "ri-share-forward-fill",
    id: "export",
    selected: false,
  },
];

/**
 * URL Permission
 */
export const URLPermission = [
  {
    value: "View",
    selected: true,
  },
  {
    value: "Edit",
    selected: false,
  },
];

/**
 * Card Theme
 */
export const cardTheme = [
  {
    value: "light",
    icon: "ri-sun-fill",
    selected: true,
  },
  {
    value: "dark",
    icon: "ri-moon-fill",
    selected: false,
  },
];
